import { CommonModule, DatePipe, JsonPipe, NgClass } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ViewChildren
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import * as _ from 'lodash';
import { ConfirmationService, MessageService } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { CalendarModule } from "primeng/calendar";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ConfirmPopupModule } from "primeng/confirmpopup";
import { DropdownModule } from "primeng/dropdown";
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from "primeng/inputtext";
import { MenuModule } from "primeng/menu";
import { PaginatorModule } from "primeng/paginator";
import { TableModule } from "primeng/table";
import { ToastModule } from "primeng/toast";
import { TooltipModule } from 'primeng/tooltip';
import { AppIcons } from "../../app.icons";
import { AppSettings } from "../../app.settings";
import { TruncatePipe } from "../../pipes/truncate.pipe";
import { CommonBindingDataService } from "../../services/common-binding-data.service";
import { ConfigService } from "../../services/config.service";
import { MetaDataService } from "../../services/meta-data.service";
import { UiService } from "../../services/ui.service";
import { MiImageContainerComponent } from "../../ui-sharable/mi-image-container/mi-image-container.component";
import { FilterService } from "../advance-filter-form/filter.service";
import { FilterBoxComponent } from "../filter-box/filter-box.component";
import { ManageColumnComponent } from "../manage-column/manage-column.component";
import { ManageColumnService } from "../manage-column/manage-column.service";
import { ErrorSkeltonComponent } from "../mi-defer/error-skelton/error-skelton.component";
import { TableSkeltonComponent } from "../mi-defer/table-skelton/table-skelton.component";
import { GetTimeForQueueComponent } from "../mi-fields/get-time-for-queue/get-time-for-queue.component";
import { QueueLocationDropdownComponent } from "../mi-fields/queue-location-dropdown/queue-location-dropdown.component";
import { PerPageColumnsComponent } from "../per-page-columns/per-page-columns.component";
import { QuickFilterFormComponent } from "../quick-filter-form/quick-filter-form.component";
import { MITableService } from "./mitable.service";
import { UserConfig } from "./models/config";
import type { Column } from "./models/table";
import { StatusCellComponent } from "./status-cell/status-cell.component";
import { ChangeReviewStatusComponent } from "app/modules/change-review/components/change-review-status/change-review-status.component";
import { EntityType } from "../../models/entity.models";

interface PageEvent {
  first: number;
  rows: number;
  page: number;
  pageCount: number;
}

enum IncidentStatus {
  Open = 'Open',
  UnderReview = 'Under Review',
  InProgress = 'In Progress',
  Resolved = 'Resolved'
}

@Component({
  selector: "app-mi-table",
  templateUrl: "./mi-table.component.html",
  styleUrls: ["./mi-table.component.scss"],
  standalone: true,
  imports: [
    TableSkeltonComponent,
    ErrorSkeltonComponent,
    InputTextModule,
    ButtonModule,
    PaginatorModule,
    PerPageColumnsComponent,
    MenuModule,
    TableModule,
    StatusCellComponent,
    ToastModule,
    ConfirmDialogModule,
    TranslateModule,
    ManageColumnComponent,
    PerPageColumnsComponent,
    TooltipModule,
    QuickFilterFormComponent,
    NgClass,
    DatePipe,
    DropdownModule,
    FormsModule,
    CalendarModule,
    InputSwitchModule,
    FormsModule,
    GetTimeForQueueComponent,
    QueueLocationDropdownComponent,
    InputSwitchModule,
    RouterModule,
    TruncatePipe,
    MiImageContainerComponent,
    CommonModule,
    ConfirmPopupModule,
    FilterBoxComponent,
    NgClass,
    ChangeReviewStatusComponent,
    JsonPipe
  ],
})
export class MITableComponent implements OnInit, OnChanges {
  @ViewChildren('queueLocationButton') queueLocationRef: QueryList<ElementRef>;
  miIcons = AppIcons;
  searchValue: string = '';
  @Output() onBtnClick: EventEmitter<Record<string, unknown>> = new EventEmitter();
  @Input() collectionOfColumns: Array<Record<string, unknown>>;
  @Input() attributeLabels: Record<string, string>;
  @Input() data: Array<Record<string, unknown>>;
  @Input() entityName: string;
  @Input() staticEntity: string;
  @Input() entityNameForBulkUpdate: string;
  @Input() isLoading: boolean;
  @Input() uniqueId: string;
  @Input() isEntity: boolean;
  @Input() isLeaveRequest: boolean;
  @Input() filterSize: number = 3;
  @Input() filterList: Array<Record<string, unknown>>;
  @Input() filterFields: Array<Record<string, unknown>> = [];
  @Input() defaultFilterValues: any = {};
  @Input() label: string;
  @Input() bulkUpdateLabel = 'Update';
  @Input() bulkDeleteLabel = 'Delete';
  @Input() bulkPrintLabel = 'Print';
  @Input() attributeData: Record<string, unknown>;
  @Input() rowItems: Array<Record<string, unknown>>;
  @Input() bulkSelectionsItems: Array<Record<string, unknown>>;
  @Input() showBulkUpdateDialog: boolean;
  @Input() showBulkLeaveUpdateDialog: boolean;
  @Input() visible: boolean;
  @Input() totalRecords: number;
  @Input() visiblePrintLabel: boolean;
  @Input() bulkUpdateHeader: string;
  @Input() reviewHeader: string;
  @Input() btnUpdate: Record<string, unknown>;
  @Input() emptyResultMsg: string = this.cs.getLabel('lbl_no_results_to_show');
  @Input() entityNameToDisplay: string = this.cs.getLabel('Vehicle');
  @Input() message: string;
  @Input() header: string;
  @Input() isDeletedTab: boolean = false;
  auditLogsFilterType: EntityType;
  @Input() childTableViewCode: string;
  @Input() tableViewCode: string = AppSettings.VIEW_CODE.DEFAULT_TABLE_VIEW;
  @Input() headerWidget: boolean = true;
  @Input() isOrderHistory: boolean = false;

  @Output() onClickInvoiceDownload = new EventEmitter<Record<string, unknown>>();
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() showBulkUpdateDialogChange = new EventEmitter<boolean>();
  @Output() onPageChange: EventEmitter<PageEvent> = new EventEmitter();
  @Output() itemPerPageChange: EventEmitter<number> = new EventEmitter();
  @Output() onToggleOverLay: EventEmitter<boolean> = new EventEmitter();
  @Output() onDeleteRowConfirmation: EventEmitter<Record<string, unknown>> = new EventEmitter();
  @Output() onSearchValueChange: EventEmitter<string> = new EventEmitter();
  @Output() onUpdate: EventEmitter<Record<string, unknown>> = new EventEmitter();
  @Output() onChangeStatus: EventEmitter<Record<string, unknown>> = new EventEmitter();
  @Output() onChangeAssignDriverGroup: EventEmitter<Record<string, unknown>> = new EventEmitter();
  @Output() onChangeDefaultVehicle: EventEmitter<Record<string, unknown>> = new EventEmitter();
  @Output() onChangeSelectCheckInLocation: EventEmitter<Record<string, unknown>> = new EventEmitter();
  @Output() onChangeOffDutyReason: EventEmitter<Record<string, unknown>> = new EventEmitter();
  @Output() onChangeOnDutyReason: EventEmitter<Record<string, unknown>> = new EventEmitter();
  @Output() onEventStatusChangeEvent: EventEmitter<Record<string, unknown>> = new EventEmitter();
  @Output() onOrganizationStatusChangeEvent: EventEmitter<Record<string, unknown>> = new EventEmitter();
  @Output() queueLocationFromMiTable: EventEmitter<Record<string, unknown>> = new EventEmitter();
  @Output() onDelete = new EventEmitter<Record<string, unknown>>();
  @Output() onRowSelection = new EventEmitter<Record<string, unknown>>();
  @Output() onValueChange = new EventEmitter<Record<string, unknown>>();
  @Output() onBulkDataUpdateEvent = new EventEmitter<boolean>();
  @Output() onBulkLeaveDataUpdateEvent = new EventEmitter<boolean>();
  @Output() onBulkDataDeleteEvent = new EventEmitter<Array<string>>();
  @Output() setCurrentRowData = new EventEmitter<Record<string, unknown>>();
  @Output() setCurrentRowDataForLeaveApprove = new EventEmitter<Record<string, unknown>>();
  @Output() setCurrentRowDataForLeaveReject = new EventEmitter<Record<string, unknown>>();
  @Output() onTransportationDateChange: EventEmitter<Record<string, unknown>> = new EventEmitter();
  @ViewChild(QuickFilterFormComponent) quickFilterCmp!: QuickFilterFormComponent;
  @Output() onAssignDriver: EventEmitter<Record<string, unknown>> = new EventEmitter();
  @Output() onSortData: EventEmitter<Record<string, unknown>> = new EventEmitter();
  @Output() onStaticBulkDataUpdateEvent: EventEmitter<Record<string, unknown>> = new EventEmitter();

  selectedFilterCount: number = 0;
  isStatusDialogShow = false;
  statusData: Record<string, unknown>;
  columns: Array<Record<string, unknown>>;
  manageCols: Array<Record<string, unknown>>;
  selectedData: Array<Record<string, unknown>>;
  cols: Array<Record<string, unknown>> = [];
  selectedColumns!: Column[];
  btnLabel: string;
  value2: string;
  columnValue: number = 50;
  first2: number = 0;
  value: string;
  rows2: number = 10;
  @Input() itemsPerPage: number;
  isVisible: boolean = false;
  show: boolean = false;
  position: string = "center";
  selectedRows: Array<Record<string, unknown>>;
  isModal: boolean = false;
  removeOnChangeValue: Record<string, unknown>;
  currentRow: Record<string, unknown>;
  bulkRowCount: number;
  moduleName: string;
  smartSearchTimer: number;
  sortable: boolean = true;
  selectedPrintData: Array<Record<string, unknown>> = [];
  selectedEntityId: string;
  advanceFilterValue: Array<Record<string, unknown>> = [];
  quickFilterValue: Array<Record<string, unknown>> = [];
  manageColumnFromLocal: boolean = false;
  isShowDutyReason: boolean = true;
  EXCLUDE_CHECKBOX = this.appSettings.ENTITY_CODE_FOR_REMOVE_CHECKBOX;
  HOUR_MINUTE_FORMAT: string = this.metaDataService.timeHourFormat;
  dd_MMM_yyyy_hh_mm_FORMAT: string = this.metaDataService.upperDateTimeFormat;
  dd_MMM_yyyy_hh_mm_FORMAT2: string = this.metaDataService.upperDateTimeFormatPipe;
  dd_MMM_yyyy_FORMAT: string = this.metaDataService.upperDateFormat;
  hh_mm_dd_MMM_yyyy_FORMAT: string = this.metaDataService.upperTimeDateFormat;
  breakLabel: string;
  breaksLabel: string;
  isQueueLocationBtnDisabled: boolean = true;
  EVENT_STATUS = AppSettings.EVENT_STATUS;
  DRIVER_TYPE = AppSettings.DRIVER_TYPE;
  entityImage: string;
  defaultLoaderImg = AppSettings.DEFAULT_LOADER_IMAGE;
  exclude_modules: Array<string> = [];
  titleForTransportationEndDate = this.cs.getLabel('passengers.title_for_transportation_end_date_in_passenger_list')
  codesToRemoveFromManageColumn = ["features", "vehicle_images", 'driver_profile_image', "passenger_profile_image", "event_image", "off_duty_reason", "info", "action", "driver_entity_id", 'parent_order_id', 'sponsor_entity_id'];
  filterValues: Record<string, unknown>;
  sortOrderSortType: Record<string, unknown>;

  getCodesToRemoveFromManageColumn(): string[] {
    const baseCodes = [...this.codesToRemoveFromManageColumn];
    return baseCodes;
  }
  skipScroll = [
    'leave_management_request',
    'leave_management_history'
  ]
  selectedFilter: Record<string, unknown>;
  parentOrder: any;
  statusColsArray = ['product_status', 'site_status', 'order_status', 'protocol_status', 'sponsor_status', 'delivery_status', 'user_status', 'purchase_order_status', 'patient_status'];
  debounceTimeout: number;
  @Input() isBulkSelection: boolean = false;
  codesToFixedInManageColumn = ["order_status", "site_status", "product_status", "protocol_status", "user_status", "sponsor_status", "eventStatus", "changeReviewStatus", "delivery_status"];

  constructor(
    private cs: CommonBindingDataService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private miTableService: MITableService,
    public appSettings: AppSettings,
    private cd: ChangeDetectorRef,
    private manageColumnService: ManageColumnService,
    private filterService: FilterService,
    private configService: ConfigService,
    public metaDataService: MetaDataService,
    private uiService: UiService,
    private renderer: Renderer2,
  ) { }

  ngOnInit() {
    this.dd_MMM_yyyy_FORMAT = this.dd_MMM_yyyy_FORMAT.replace('mm', 'MM');
    this.updateEntityName();
    this.filterValues = this.filterService.getFilterState('filter');
    this.collectionOfColumns = _.reject(this.collectionOfColumns, attribute =>
      _.includes(this.getCodesToRemoveFromManageColumn(), attribute.attributeCode)
    );

    this.moduleName = this.entityName || this.uniqueId;
    if (this.entityName || this.moduleName) {
      this.getPreferredColumns();
    }
    this.btnLabel = this.cs.getLabel("label_filters");
    this.setLabel();
    this.filterSize = this.uiService.updateFilterSize(this.filterList?.length);
    this.manageColumnService.visibleColumns.subscribe(data => {
      const tempData = _.cloneDeep(data);
      this.manageCols = _.cloneDeep(tempData);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.itemsPerPage && changes.itemsPerPage.currentValue !== undefined) {
      this.rows2 = changes.itemsPerPage.currentValue;
    }
    if (changes.entityName && changes.entityName.currentValue) {
      this.moduleName = changes.entityName.currentValue;
      this.getPreferredColumns();
    }
  }

  private setFilterData() {
    const prevData = this.filterService.getFilterState(this.entityName || this.uniqueId);
    this.selectedFilterCount = prevData.selectedFilterCount;
  }
  private updateEntityName(): void {
    this.filterService.setEntityName(this.entityName || this.uniqueId);
  }

  setLabel() {
    this.breakLabel = this.cs.getLabel('lbl_break');
    this.breaksLabel = this.cs.getLabel('lbl_breaks');
  }

  clearSearch() {
    this.searchValue = "";
    this.onSearchValueChange.emit('');
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  downloadDocument(event: Event, url: string) {
    event.stopPropagation();
    if (!url) return;
    window.open(url, '_self');
  }

  getEntityLabel(code: string | null | undefined): string {
    if (!code || !(code in EntityType)) {
      return '--';
    }
    return EntityType[code as keyof typeof EntityType];
  }

  onStatusChange(rowData: Record<string, unknown>) {
    this.onChangeStatus.emit(rowData);
  }

  onDutyStatus(rowData: Record<string, unknown>) {
    this.onChangeStatus.emit(rowData);
  }

  assignDriverGroup(rowData: Record<string, unknown>) {
    this.onChangeAssignDriverGroup.emit(rowData);
  }

  defaultVehicle(rowData: Record<string, unknown>) {
    this.onChangeDefaultVehicle.emit(rowData);
  }

  selectCheckInLocation(rowData: Record<string, unknown>) {
    this.onChangeSelectCheckInLocation.emit(rowData);
  }

  invoiceDownload(rowData: Record<string, unknown>) {
    this.onClickInvoiceDownload.emit(rowData);
  }

  getStatusClassForStatus(status: IncidentStatus): string {
    switch (status) {
      case IncidentStatus.Open:
        return AppSettings.INCIDENTS_STATUS_CLASS.OPEN;
      case IncidentStatus.UnderReview:
        return AppSettings.INCIDENTS_STATUS_CLASS.UNDER_REVIEW;
      case IncidentStatus.InProgress:
        return AppSettings.INCIDENTS_STATUS_CLASS.IN_PROGRESS;
      case IncidentStatus.Resolved:
        return AppSettings.INCIDENTS_STATUS_CLASS.RESOLVED;
      default:
        return AppSettings.INCIDENTS_STATUS_CLASS.DEFAULT;
    }
  }

  setCurrentRow(rowData: Record<string, unknown>) {
    this.currentRow = rowData;
    this.setCurrentRowData.emit(rowData);
  }

  setCurrentRowForLeaveApprove(rowData: Record<string, unknown>) {
    this.setCurrentRowDataForLeaveApprove.emit(rowData);
  }

  setCurrentRowForLeaveReject(rowData: Record<string, unknown>) {
    this.setCurrentRowDataForLeaveReject.emit(rowData);
  }

  delete(deleteType: string) {
    let acceptLabelText;
    if (this.entityName === AppSettings.ENTITY_CODE.QUEUE) {
      acceptLabelText = this.cs.getLabel('lbl_remove');
    } else {
      acceptLabelText = this.cs.getLabel('lbl_delete')
    }
    if (this.entityName === AppSettings.ENTITY_CODE.LOCATION) {
      const bulkDeleteConfirmMsg = `${this.cs.getLabel('manage_locations.message.bulk_delete_Confirm_msg')}<br>`;
      const bulkDeleteNoteTitle = this.cs.getLabel('manage_locations.message.bulk_delete_note_title');
      const bulkDeleteNoteMsg = this.cs.getLabel('manage_locations.message.bulk_delete_note_msg');
      const bulkDeleteMsg = `<br>${this.cs.getLabel('manage_locations.message.bulk_delete_msg')}<br>`;
      this.confirmationService.confirm({
        header: this.header,
        message: `${bulkDeleteConfirmMsg}<br><strong>Note: </strong>${bulkDeleteNoteTitle}<br>${bulkDeleteNoteMsg}<br>${bulkDeleteMsg}`,
        acceptIcon: 'none',
        rejectIcon: 'none',
        rejectButtonStyleClass: 'bg-white text-color cancel',
        acceptButtonStyleClass: 'bg-red-500 delete',
        acceptLabel: acceptLabelText,
        rejectLabel: this.cs.getLabel('lbl_cancel'),
        accept: () => {
          if (deleteType === AppSettings.DELETE_TYPE.ROW) {
            this.onDelete.emit(this.currentRow as Record<string, unknown>);
          } else if (deleteType === AppSettings.DELETE_TYPE.BULK) {
            this.onBulkDataDeleteEvent.emit(this.selectedRows?.map(ele => {
              return (ele as Record<string, unknown>).id as string;
            }) || []);
          }
          this.clearSelected();

        },
        reject: () => {
        }
      });
    } else {
      this.confirmationService.confirm({
        header: this.header,
        message: this.message,
        acceptIcon: 'none',
        rejectIcon: 'none',
        rejectButtonStyleClass: 'bg-white text-color cancel',
        acceptButtonStyleClass: 'bg-red-500 delete',
        acceptLabel: acceptLabelText,
        rejectLabel: this.cs.getLabel('lbl_cancel'),
        accept: () => {
          if (deleteType === AppSettings.DELETE_TYPE.ROW) {
            this.onDelete.emit(this.currentRow.id as Record<string, unknown>);
          } else if (deleteType === AppSettings.DELETE_TYPE.BULK) {
            this.onBulkDataDeleteEvent.emit(this.selectedRows?.map(ele => {
              return (ele as Record<string, unknown>).id as string;
            }) || []);
          }
          this.clearSelected();

        },
        reject: () => {
        }
      });
    }
  }

  deleteLeave() {
    this.confirmationService.confirm({
      header: this.header,
      message: this.message,
      acceptIcon: '',
      rejectIcon: '',
      rejectButtonStyleClass: 'bg-white text-color',
      acceptButtonStyleClass: 'bg-red-500',
      accept: () => {
        this.onBulkDataDeleteEvent.emit(this.selectedRows?.map(ele => {
          return (ele as Record<string, unknown>).id as string;
        }) || []);
      },
      reject: () => {
      }
    });
  }

  changeStatusOfEntity() {
    this.onChangeStatus.emit(this.currentRow);
  }

  onAdd() {
    this.onBtnClick.emit();
  }

  onFiltersPopup() {
    this.show = true;
  }

  openDialog() {
    this.isModal = true;
  }

  selectionChange() {
    this.bulkRowCount = this.selectedRows.length;
    this.miTableService.bulkRowCount.next(this.bulkRowCount);
    this.miTableService.selectedRows.next(this.selectedRows);
  }

  showBulkRowDialog() {
    this.showBulkUpdateDialog = true;
    this.bulkRowCount = this.selectedRows?.length;
    this.cd.detectChanges();
  }

  showBulkLeaveDialog() {
    this.visible = true;
    this.showBulkLeaveUpdateDialog = true;
    this.bulkRowCount = this.selectedRows.length;
  }

  clearSelected(): void {
    this.selectedRows = [];
  }

  showPrintLabelDialog() {
    this.visiblePrintLabel = true;
    this.bulkRowCount = this.selectedRows.length;
  }

  showFilterDialog(position: string) {
    this.position = position;
    this.show = true;
    this.cd.detectChanges();
    const elements = document.querySelectorAll('.filter-item');
    if (elements.length > 0) {
      elements.forEach(el => this.renderer.removeClass(el, 'active'));
      this.renderer.addClass(elements[0], 'active');
    }

  }

  onToggle() {
    this.isModal = false;
    this.visible = false;
  }

  onSearch(event: Event) {
    const target = event.target as HTMLInputElement;
    const value = target.value;

    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    this.debounceTimeout = setTimeout(() => {
      this.onSearchValueChange.emit(value);
    }, 300) as unknown as number;
  }

  onPageChange2(event: PageEvent) {
    this.onPageChange.emit(event);
  }

  onRowSelect(event: Record<string, unknown>) {
    this.onRowSelection.emit(event);
  }

  onRowUnselect(event: Record<string, unknown>) {
    this.onRowSelection.emit(event);
  }

  toggleCheckbox(event: MouseEvent) {
    event.stopPropagation();
    event.preventDefault();
    const checkbox = event.target as HTMLInputElement;
    checkbox.checked = !checkbox.checked;
  }


  onUpdateColumns(event) {
    this.selectedColumns = event;
    this.isModal = false;

    const data = {
      config: JSON.stringify(event),
      forTenantCode: this.configService.getForTenantCode(),
      prefType: AppSettings.USER_PREFERENCE.COLUMN,
      viewCode: this.childTableViewCode ? this.childTableViewCode : 'DEFAULT_TABLE_VIEW'
    };

    if (this.entityName) {
      this.miTableService.updateUserEntityConfig(this.entityName, data, this.tableViewCode).subscribe(() => {
        this.setColumns(event);
      });
    } else {
      localStorage.setItem(this.uniqueId, JSON.stringify(event));
      this.setColumns(event);
    }
  }
  getPreferredColumns() {
    if (this.moduleName === 'order' && this.isOrderHistory) {
      const columns = _.cloneDeep(this.collectionOfColumns);
      this.setColumns(columns);
    } else {
      if (this.isEntity) {
        this.getColumnsFromUserEntityConfig();
        this.manageColumnFromLocal = false;
      } else {
        this.getColumnsFromLocalStorage();
        this.manageColumnFromLocal = true;
      }
    }
  }

  private getColumnsFromUserEntityConfig() {
    this.miTableService.getUserEntityConfig(this.entityName, AppSettings.USER_PREFERENCE.COLUMN, this.childTableViewCode ? this.childTableViewCode : this.tableViewCode).subscribe((res: UserConfig) => {
      const configObject = res.config ? JSON.parse(res.config) : null;
      const restoreDefault = Math.min(this.collectionOfColumns?.length || 0, 6);
      const columns = configObject && Object.keys(configObject).length !== 0 || configObject.length > 0 ? configObject : this.collectionOfColumns.slice(0, restoreDefault);
      this.setColumns(columns);
    });
  }

  private getColumnsFromLocalStorage() {
    const storedColumns = JSON.parse(localStorage.getItem(this.uniqueId));
    const restoreDefault = Math.min(this.collectionOfColumns?.length || 0, 6);
    const columns = storedColumns && storedColumns.length !== 0 ? storedColumns : this.collectionOfColumns.slice(0, restoreDefault);
    this.setColumns(columns);
  }

  private setColumns(columns: any[]) {
    if (this.entityName && !this.moduleName) {
      this.moduleName = this.entityName;
    }
    columns = _.reject(columns, attribute =>
      _.includes(this.getCodesToRemoveFromManageColumn(), attribute.attributeCode)
    );
    this.columns = columns;
    this.selectedColumns = columns;
    this.manageCols = _.cloneDeep(columns);
    this.manageColumnService.changeVisibleColumnsData(this.manageCols);
    this.updateCollectionOfColumns();
  }

  private updateCollectionOfColumns() {
    this.collectionOfColumns?.filter((el) => {
      el.selected = this?.columns?.some((f) => f.attributeCode === el.attributeCode);
    });

    this.manageColumnService.changeSelectedAndCollectionData(this.collectionOfColumns);
  }

  updateRows(value: number) {
    this.rows2 = value;
    this.itemPerPageChange.emit(this.rows2);
  }

  onToggleManageColumn() {
    this.isModal = true;
  }

  onFilterValueChange(filterFlag, event) {
    filterFlag ? (this.advanceFilterValue = event) : (this.quickFilterValue = event);
    const combineFilter = { ...this.advanceFilterValue, ...this.quickFilterValue }
    this.selectedFilterCount = this.countNonNullValues(combineFilter)
    this.onValueChange.emit(combineFilter);
  }


  countNonNullValues(obj) {
    return _.reduce(obj, (count, value) => {
      return (value !== null && value !== "" && value?.length !== 0) ? count + 1 : count;
    }, 0);
  }

  setAllValuesToNull(obj) {
    return _.mapValues(obj, () => null);
  }

  clearFilter() {
    this.selectedFilterCount = 0;
    if (this.staticEntity === 'change_review') {
      AppSettings.PROTOCOL_ID = null;
    }
    this.advanceFilterValue = this.setAllValuesToNull(this.advanceFilterValue);
    this.quickFilterValue = this.setAllValuesToNull(this.quickFilterValue);
    const combineFilter = { ...this.advanceFilterValue, ...this.quickFilterValue }
    this.onValueChange.emit(combineFilter);
    const filter = _.cloneDeep(this.filterList);
    this.filterList = [];
    this.cd.detectChanges();
    this.filterList = filter;
  }


  onBulkDataUpdate(event) {
    this.selectedRows = [];
    this.showBulkUpdateDialog = false;
    this.visible = false;
    this.onBulkDataUpdateEvent.emit(event);
  }

  onBulkLeaveDataUpdate(event) {
    this.selectedRows = [];
    this.showBulkLeaveUpdateDialog = false;
    this.visible = false;
    this.onBulkLeaveDataUpdateEvent.emit(event);
  }

  onTransportationDateSelect(event, data) {
    this.onTransportationDateChange.emit({ newDate: event, row: data })
  }

  onEventStatusChange(rowData, event) {
    this.onEventStatusChangeEvent.emit({ ...rowData, checked: event.checked });
  }

  onOrganizationStatusChange(rowData, event) {
    this.onOrganizationStatusChangeEvent.emit({ ...rowData, checked: event.checked });
  }

  rowMouseOver(rowData) {
    rowData.showRowMenu = true;
  }

  rowMouseOut(rowData) {
    rowData.showRowMenu = false;
  }

  getQueueLocationChange(event, rowIndex) {
    this.queueLocationFromMiTable.emit(event);
    this.queueLocationRef.forEach((ele, index) => {
      if (index === rowIndex) {
        ele.nativeElement.disabled = false;
      }
    })
  }

  assignDriver(rowData) {
    this.onAssignDriver.emit(rowData);
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.filterSize = this.uiService.updateFilterSize();
  }

  onStaticBulkDataUpdate(event) {
    this.onStaticBulkDataUpdateEvent.emit(event)
  }

  setSortColumnSortOrder(sortOrderSortColumn) {
    this.sortOrderSortType = sortOrderSortColumn;
  }

  sortData(columnData) {
    if (columnData.isSortable) {
      columnData.sortOrder = this.sortOrderSortType?.order;
      this.onSortData.emit(columnData);
    }
  }

  showStatusCheck(attributeCode) {
    const attributeStatusArr = ['product_status', 'site_status', 'order_status', 'protocol_status', 'sponsor_status'];
    if (attributeStatusArr.includes(attributeCode)) {
      return 'status';
    } else {
      return null;
    }
  }

  setParentOrder(rowData: any) {
    const parentOrderId = rowData?.parent_order_id;
    this.parentOrder = rowData?.relatedData?.find(
      (order: any) => order.entityCode === 'order' && order.id === parentOrderId
    );
  }

  formatDeliveryDays(days: number[]): string {
    if (!days || days.length === 0) return '--';

    const dayMap = {
      1: 'Mon',
      2: 'Tue',
      3: 'Wed',
      4: 'Thu',
      5: 'Fri',
      6: 'Sat',
      7: 'Sun'
    };

    const sortedDays = [...days].sort((a, b) => a - b);
    const dayNames = sortedDays.map(day => dayMap[day]);

    if (dayNames.length === 1) {
      return dayNames[0];
    }

    let isConsecutive = true;
    for (let i = 1; i < sortedDays.length; i++) {
      if (sortedDays[i] !== sortedDays[i - 1] + 1) {
        isConsecutive = false;
        break;
      }
    }

    if (isConsecutive) {
      return `${dayMap[sortedDays[0]]}-to-${dayMap[sortedDays[sortedDays.length - 1]]}`;
    }

    return dayNames.join('-');
  }

  formatDeliveryTime(from: number, to: number): string {
    if (!from || !to) return '';

    const fromDate = new Date(from);
    const toDate = new Date(to);

    const formatTime = (date: Date) => {
      const hours = date.getHours();
      const minutes = date.getMinutes();
      return `${hours}:${minutes.toString().padStart(2, '0')}`;
    };

    return `${formatTime(fromDate)}-${formatTime(toDate)}`;
  }

  formatSiteAddress(rowData) {
    const parts = [
      rowData.site_address_short_name,
      rowData.site_address_line_1,
      rowData.site_address_line_2,
      rowData.site_street,
      rowData.site_city,
      rowData.site_state,
      rowData.site_zip
    ].filter(Boolean);

    return parts.join(', ');

  }

  formatSponsorAddress(rowData) {
    const parts = [
      rowData.spn_addr_name,
      rowData.spn_addr_line_1,
      rowData.spn_addr_line_2,
      rowData.spn_street,
      rowData.spn_city,
      rowData.spn_state,
      rowData.spn_zip
    ].filter(Boolean);

    return parts.join(', ');

  }

  formatAddress(rowData) {
    const parts = [
      rowData.address_short_name,
      rowData.address_line_1,
      rowData.address_line_2,
      rowData.street,
      rowData.city,
      rowData.state,
      rowData.zip
    ].filter(Boolean);

    return parts.join(', ');

  }


  getFormattedDate(item: any): string {
    if (!item) return '--';

    const rawDate = typeof item === 'string' ? item : item?.values?.expiry_date;
    if (!rawDate) return '--';

    const [day, month, year] = rawDate.split('/').map(Number);
    const date = new Date(year, month - 1, day);
    const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-GB', options);
  }


}
